import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'
import { ADMIN } from '../../constants/userRoles'

const AdminRoute = ({ ...routeProps }) => {
  const { isAuth, user } = useSelector((state) => state.auth)

  if (!isAuth) return <Redirect to="/login" />
  if (!user || user.role !== ADMIN) return <Redirect to="/app" />

  return <Route {...routeProps} />
}

export default AdminRoute

